export const getBase64ImageType = (base64String: string): string => {
    // Determine the image format based on the first character
    switch (base64String.charAt(0)) {
      case 'i':
        return 'png';
      case '/':
        return 'jpeg';
      case 'R':
        return 'gif';
      case 'U':
        return 'webp';
      case 'P':
        return 'svg+xml';
      default:
        // Default to PNG format if we can't determine the format
        return 'png';
    }
  };
  
  export const isEmpty = (value: any): boolean => {
    return value === null || value === undefined || value === '';
  };
